
import React from 'react';
import ControlsBar from './ControlsBar';
import SearchFilterBar from './SearchFilterBar';

const SearchHeader = ({
  viewMode,
  onViewModeChange,
  resultsCount,
  filters = {},
  categories = [],
  onFiltersChange = () => {},
  onSearch = () => {},
  isLoading = false
}) => {
  return (
    <div className="bg-background/95 backdrop-blur-sm border-b border-border transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <SearchFilterBar
          filters={filters}
          categories={categories}
          onFiltersChange={onFiltersChange}
          onSearch={onSearch}
          isLoading={isLoading}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <ControlsBar
          resultsCount={resultsCount}
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
        />
      </div>
    </div>
  );
};

export default SearchHeader;
